import React, { useState } from "react";
import "./dashboard.css"; // reuse existing dashboard styling

function N8nIntegration() {
  const [apiKey, setApiKey] = useState("");
  const [status, setStatus] = useState("Not Connected");

  const connectN8n = () => {
    if (!apiKey) return alert("Enter your n8n API Key");
    setStatus("Connected");
  };

  return (
    <div className="page-container">
      <h2 className="page-title">n8n Integration</h2>

      <div className="card">
        <h3>Automation Setup</h3>
        <p className="subtext">
          Connect your dashboard to n8n to automate tasks, trigger workflows, and sync data.
        </p>

        <input
          type="text"
          placeholder="Your n8n API Key"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          className="integration-input"
        />

        <button className="primary-btn" onClick={connectN8n}>
          Connect
        </button>

        <div className="integration-status">
          <h4>Status:</h4>
          <span className={status === "Connected" ? "connected" : "disconnected"}>
            {status}
          </span>
        </div>
      </div>

      <div className="card">
        <h3>Connected Workflows</h3>
        <ul className="workflow-list">
          <li>New Wallet → Trigger n8n workflow</li>
          <li>Activity Heatmap → Sync to Google Sheets</li>
          <li>Transactions → Update Slack channel</li>
        </ul>
      </div>
    </div>
  );
}

export default N8nIntegration;
